import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useParams} from 'react-router-dom';
import {useUniversityDetailQueryConfig} from '../../../../query/University/Query';
import {useResponseDetailQueryConfig} from '../../../../query/Response/Query';
import {useResponseAnswerIndexQueryConfig} from '../../../../query/ResponseAnswer/Query';
import {useQuery} from '@tanstack/react-query';
import ResponseDetailContent from './ResponseDetailContent';

const ResponseDetail: FunctionComponent = () => {
    const params = useParams();

    const universityId = Number(params.id),
        responseId = Number(params.responseId);

    const [universityConfig] = useUniversityDetailQueryConfig(universityId);
    const [responseConfig] = useResponseDetailQueryConfig(universityId, responseId);
    const [answerConfig] = useResponseAnswerIndexQueryConfig(responseId);

    const universityQuery = useQuery(universityConfig);
    const responseQuery = useQuery(responseConfig);
    const answerQuery = useQuery(answerConfig);

    return (
        <Page className={'admin-response-detail-page'}>
            { (universityQuery.data && responseQuery.data && answerQuery.data) &&
                <ResponseDetailContent
                    university={universityQuery.data}
                    response={responseQuery.data}
                    answers={answerQuery.data} />
            }
        </Page>
    );
};

export default ResponseDetail;
